import React from 'react';

interface DisplaySettingsFormState {
  timeFormat: '12h' | '24h';
  playerSortBy: 'firstName' | 'lastName' | 'number';
}

interface DisplaySettingsSectionProps {
  formState: DisplaySettingsFormState;
  onTimeFormatChange: (format: '12h' | '24h') => void;
  onPlayerSortChange: (sortBy: 'firstName' | 'lastName' | 'number') => void;
}

export const DisplaySettingsSection: React.FC<DisplaySettingsSectionProps> = ({
  formState,
  onTimeFormatChange,
  onPlayerSortChange
}) => {
  return (
    <div className="space-y-3">
        <div>
          <label className="form-label">Time Format</label>
          <div className="flex items-center space-x-4">
            <button
              type="button"
              onClick={() => onTimeFormatChange('12h')}
              className={`px-4 py-2 rounded-xl border ${
                formState.timeFormat === '12h'
                  ? 'bg-secondary-hover border-primary text-primary font-semibold'
                  : 'bg-white border-stone text-dark'
              }`}
            >
              12-hour (1:00 PM)
            </button>
            <button
              type="button"
              onClick={() => onTimeFormatChange('24h')}
              className={`px-4 py-2 rounded-xl border ${
                formState.timeFormat === '24h'
                  ? 'bg-secondary-hover border-primary text-primary font-semibold'
                  : 'bg-white border-stone text-dark'
              }`}
            >
              24-hour (13:00)
            </button>
          </div>
        </div>
        
        <div>
          <label className="form-label">Default Player Sort Order</label>
          <p className="text-xs text-stone mb-2">How players should be sorted by default in depth charts and roster views</p>
          <div className="flex items-center space-x-4">
            <button
              type="button"
              onClick={() => onPlayerSortChange('firstName')}
              className={`px-4 py-2 rounded-xl border ${
                formState.playerSortBy === 'firstName'
                  ? 'bg-secondary-hover border-primary text-primary font-semibold'
                  : 'bg-white border-stone text-dark'
              }`}
            >
              First Name
            </button>
            <button
              type="button"
              onClick={() => onPlayerSortChange('lastName')}
              className={`px-4 py-2 rounded-xl border ${
                formState.playerSortBy === 'lastName'
                  ? 'bg-secondary-hover border-primary text-primary font-semibold'
                  : 'bg-white border-stone text-dark'
              }`}
            >
              Last Name
            </button>
            <button
              type="button"
              onClick={() => onPlayerSortChange('number')}
              className={`px-4 py-2 rounded-xl border ${
                formState.playerSortBy === 'number'
                  ? 'bg-secondary-hover border-primary text-primary font-semibold'
                  : 'bg-white border-stone text-dark'
              }`}
            >
              Number
            </button>
          </div>
        </div>
      </div>
  );
}; 